<template>
	<template v-if="data">
		<section>
			<ButtonBack />

			<h1>{{ data.title }}</h1>
			<span>{{ $formatDate(data.publishedDate) }}</span>

			<TheBox :title="'Entscheidung:'">
				<div :class="`has-status has-status--${$getStateColor('case', data.state)}`">
					{{ $getStateFullLabel('case', data.state, false) }}
				</div>

				<h3>Begründung</h3>
				<div class="text">{{ data.reasonText }}</div>
			</TheBox>

			<TheBox :title="'Beschwerde:'" v-for="complaint in data.complaints" :key="complaint.id">
				<div class="text">{{ complaint.text }}</div>
			</TheBox>
		</section>
	</template>
	<section v-else-if="loading === false">
		<ButtonBack />
		<el-alert :title="texts.general.emptyText" type="error" effect="dark" :closable="false" />
	</section>
</template>

<script lang="ts">
import { getPublicCase } from '@/requests/cases';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
import type { FormInstance } from 'element-plus';
import { defineComponent, ref } from 'vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import TheBox from '../components/TheBox.vue';
import TheButton from '../components/TheButton.vue';
import { CasePublicResponse } from '../types/types';
import { texts } from '../utils/texts.js';

export default defineComponent({
	name: 'FallDetailPublicView',
	data() {
		return {
			data: null as CasePublicResponse | null,
			waiting: false,
			loading: true,
		};
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		ButtonBack,
		TheButton,
		TheBox,
	},
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	computed: {
		texts() {
			return texts;
		},
	},
	methods: {
		async loadCase() {
			const loading = startLoading('#fall');

			const result = await getPublicCase(this.id);
			if (result.success) {
				this.data = result.data;
			}

			this.loading = false;
			stopLoading(loading);
		},
	},
	mounted() {
		this.loadCase();
	},
});
</script>

<style lang="scss" scoped>
#fall {
	.box {
		margin-top: 3rem;
		margin-bottom: 3rem;
		h3 {
			margin-top: 2rem;
		}
	}
}
</style>
